export default "__VITE_ASSET__a277cadf__"